import { FC } from "react";

export interface IChallengeDetailProgressProps {
    progress: number;
    total: number;
    label?: string;
}

export const ChallengeDetailProgress: FC<IChallengeDetailProgressProps> = ({ progress, total, label }) => {
    return (
        <span>
            {`${progress} / ${total}${label ? ` ${label}` : '' }`}
        </span>
    );
}